import PropTypes from 'prop-types';
import cx from 'classnames';
import BrandPanel from './BrandPanel';
import LanguageSwitcher from './LanguageSwitcher';
import ThemePill from './ThemePill';
import './AuthShell.css';

/**
 * AuthShell — page-level layout for all public pages (Login,
 * PasswordReset, AcceptInvitation, Maintenance, public-facing 404).
 *
 * Composition: full-bleed brand panel (clip-path polygon, animated
 * gradient + orbs) on the left, white form card area on the right.
 * Stacks vertically on tablet/mobile.
 *
 * Slots:
 *   - children: rendered inside the right-hand form area, centred.
 *     Pass an <AuthCard /> for the standard form treatment.
 *   - brandWelcome / brandWelcomeStrong / brandTagline: override the
 *     default copy on the brand panel.
 */
const AuthShell = ({
  children,
  brandWelcome,
  brandWelcomeStrong,
  brandTagline,
  brandAttribution,
  className,
}) => (
  <div className={cx('qhs-auth-shell', className)}>
    <span className="qhs-auth-shell__stripe" aria-hidden="true" />
    <ThemePill />
    <LanguageSwitcher />
    <BrandPanel
      welcome={brandWelcome}
      welcomeStrong={brandWelcomeStrong}
      tagline={brandTagline}
      attribution={brandAttribution}
    />
    <main className="qhs-auth-shell__form-area" role="main">
      <div className="qhs-auth-shell__form-inner">{children}</div>
    </main>
  </div>
);

AuthShell.propTypes = {
  children: PropTypes.node,
  brandWelcome: PropTypes.string,
  brandWelcomeStrong: PropTypes.string,
  brandTagline: PropTypes.string,
  brandAttribution: PropTypes.string,
  className: PropTypes.string,
};

export default AuthShell;
